<template>
  <router-link to="/config" tag="li"><a><i class="fa fa-gear"></i><span>Konfigurasi Aplikasi</span></a></router-link>
</template>
<script>
export default {
  name: 'config-management-nav'
}
</script>




// WEBPACK FOOTER //
// Navigation.vue?8b52d020